export const RECEIPT_ROUTING = [
    {
        path: '/receipt',
        name: 'receipt',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Phiếu xuất', pathName: 'receipt', icon: 'fa fa-file-text-o' },
            ]
        },
        component: () => import('./Receipt.vue'),
        redirect: { name: 'receipt-index' },
        children: [
            {
                path: '/phieu-xuat-kho.html',
                name: 'receipt-index',
                component: () => import('./list/List.vue'),
            },
            {
                path: '/phieu-xuat-kho/:id',
                name: 'receipt-detail',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết phiếu xuất', pathName: 'receipt-detail', icon: 'fa fa-file-text-o' },
                ] },
                component: () => import('./detail/Detail.vue'),
            }
        ]
    }
];